export const DEACTIVATABLE_TYPES = {
  PRODUCT: 'Product',
  MODIFIER: 'Modifier'
};
